module.exports = __webpack_public_path__ + "static/media/pattern-4.a2c2b3f2.png";